// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__jyV_V","messages":"Chat_messages__28vTI","dateDivider":"Chat_dateDivider__14BYj"};